import LocalLanding from "./LocalLanding";
export default function LandingSintra() {
    return (
        <LocalLanding
            city="Sintra"
            canonicalSlug="remodelacoes-sintra"
            hero="https://images.unsplash.com/photo-1750832693915-fae6bf21d329?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920"
        />
    );
}
